import type {
  IDedicatedException,
  IResource,
  ResourceType
} from "@gettactic/api";

/**
 * How many people may hold the resource as dedicated owners at once. Mirrors
 * core's `Resource.DedicatedSeats()`: only a workspace group has several seats.
 */
export const dedicatedSeatCount = (resource: {
  type: string;
  total_slots: number;
}): number =>
  resource.type === "workspace" && resource.total_slots > 1
    ? resource.total_slots
    : 1;

/** True when every dedicated seat is taken, so adding someone needs room first. */
export const isDedicatedFull = (
  resource: Pick<IResource, "type" | "total_slots">,
  ownerCount: number
): boolean => ownerCount >= dedicatedSeatCount(resource);

/**
 * Types whose dedicated owners can grow past one: a desk by becoming a
 * workspace group, a workspace by adding seats. Parking and rooms cannot.
 */
export const canGainDedicatedSeats = (type: ResourceType): boolean =>
  type === "desk" || type === "workspace";

/**
 * Every release active on the day the resource was read. Payloads from before
 * shared workspaces only carry the first one, in the deprecated field.
 */
export const resourceDedicatedExceptions = (
  resource: Pick<IResource, "dedicated_exceptions" | "dedicated_exception">
): IDedicatedException[] =>
  resource.dedicated_exceptions ??
  (resource.dedicated_exception ? [resource.dedicated_exception] : []);
